<div class="video-container">
  @if (value && value.title) {
    <h3 class="title">{{ value.title }}</h3>
  }
  <div class="video-viewer">
    <grid-ui-body-item-video-player [value]="value"></grid-ui-body-item-video-player>
  </div>
  @if (value && value.description) {
    <h4 class="description">{{ value.description }}</h4>
  }
</div>
